/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.11",
    versionName: "0.2.0-nightly.2026.1.11",
    versionChannel: "nightly",
    buildDate: "2026-01-11T00:08:13.727Z",
    commitHash: "c705ebad3cd502e6fcfe65ad6198dfc0f87c8adc",
};
